export default __webpack_public_path__ + "static/02-b80a5c02ce9de44a3d01f2b935c12ba7.gif";